/* =====================================================================
   AURA NOIRE · Objetivos del carrito: muestra gratis (compra mínima) y envío gratis
   Archivo del tema: assets/aura-cart-goals.js (cargado desde layout/theme.liquid)

   QUÉ HACE
   - Mantiene al día los avisos de snippets/aura-cart-goals.liquid en la página del carrito y en el aviso
     «Artículo agregado» después de cualquier cambio del carrito (añadir, quitar, cantidad, packs de Easy Bundle,
     códigos, muestra recuperada o retirada). El cálculo lo hace Shopify en Liquid (sections/aura-cart-goals.liquid):
     aquí no se calcula ni se toca ningún precio.
   - «Retirar muestra»: quita la línea de la muestra con el mismo botón de papelera del carrito (Welcome Gift v2 lo
     registra como retirada voluntaria y ofrece «Recuperar mi muestra gratis»).
   - Solo si está activado «Desactivar los botones de pago…» (Ajustes del tema → Aura Noire · Envío y muestra):
     con la muestra y menos del mínimo desactiva «Pagar pedido», oculta los botones de pago rápido del carrito y el
     «Pagar pedido» del aviso, y lleva al carrito si se intenta pagar desde otro sitio.

   LÍMITE (IMPORTANTE)
   - Esto es INTERFAZ. No impide un pedido por /checkout directo ni por apps externas. La protección real es la regla
     de validación de pago de Shopify (Ajustes → Pantalla de pago → Reglas de pago).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__auraGoals) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.fetch || !window.DOMParser || !document.querySelector) return;

  var CFG = Object.assign({ blockUi: false, giftShow: false, giftVariant: 54136341659995 }, window.auraGoalsConfig || {});
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION = 'aura-cart-goals';
  var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)|\/discount\//;
  var timer = null, seq = 0, state = null;

  function isCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function hosts() { return document.querySelectorAll('[data-aura-goals-host]'); }

  function readState() {
    var el = document.querySelector('[data-aura-goals-host="cart"] [data-aura-goals]') ||
             document.querySelector('[data-aura-goals-host] [data-aura-goals]');
    if (!el) return state;
    return {
      gift: Number(el.getAttribute('data-gift')) || 0,
      paid: Number(el.getAttribute('data-paid')) || 0,
      goal: Number(el.getAttribute('data-gift-goal')) || 0,
      blocked: el.getAttribute('data-blocked') === 'true',
      lockText: el.getAttribute('data-lock-text') || ''
    };
  }

  /* ---------- Pago desactivado por debajo del mínimo (solo si está activado en el tema) ---------- */
  function apply() {
    state = readState() || state;
    var locked = !!(CFG.blockUi && state && state.blocked);
    document.documentElement.classList.toggle('aura-gift-locked', locked);

    // Solo se escribe en el DOM si algo cambia: el pie del carrito está observado (MutationObserver) y
    // una escritura innecesaria volvería a disparar apply() sin fin.
    var btn = document.getElementById('checkout');
    if (!btn) return;
    var note = document.getElementById('AuraCheckoutLock');
    if (locked) {
      if (!btn.disabled) { btn.disabled = true; btn.setAttribute('data-aura-locked', '1'); }
      if (!note) {
        note = document.createElement('p');
        note.id = 'AuraCheckoutLock';
        note.className = 'aura-goals-lock';
        note.setAttribute('role', 'status');
        (btn.closest('.cart__ctas') || btn).insertAdjacentElement('afterend', note);
      }
      if (note.hidden) note.hidden = false;
      if (note.textContent !== state.lockText) note.textContent = state.lockText;
      if (btn.getAttribute('aria-describedby') !== 'AuraCheckoutLock') btn.setAttribute('aria-describedby', 'AuraCheckoutLock');
    } else {
      if (btn.getAttribute('data-aura-locked')) { btn.disabled = false; btn.removeAttribute('data-aura-locked'); }
      if (note && !note.hidden) note.hidden = true;
      if (btn.getAttribute('aria-describedby') === 'AuraCheckoutLock') btn.removeAttribute('aria-describedby');
    }
  }

  function pendingGift() {
    var wg = window.__auraWelcomeGift;
    try { return !!(wg && typeof wg.needsGift === 'function' && wg.needsGift()); } catch (e) { return false; }
  }

  function isLocked() {
    if (!CFG.blockUi) return false;
    var s = readState() || state;
    if (!s) return false;
    if (s.blocked) return true;
    // La muestra está a punto de entrar (Welcome Gift la está añadiendo): se aplica ya el mismo mínimo.
    return !!(CFG.giftShow && !s.gift && s.goal > 0 && s.paid < s.goal && pendingGift());
  }

  function goToCart() {
    if (isCartPage()) {
      var g = document.querySelector('[data-aura-goals-host="cart"]');
      if (g && g.scrollIntoView) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    location.href = root + 'cart';
  }

  // Captura en window: se ejecuta antes que cualquier otro manejador del documento (incluido Welcome Gift).
  window.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el || !isLocked()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToCart();
  }, true);

  window.addEventListener('submit', function (e) {
    var sub = e.submitter;
    var form = e.target;
    var toCheckout = (sub && sub.name === 'checkout') || (form && form.querySelector && form.querySelector('input[name="checkout"]'));
    if (!toCheckout || !isLocked()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToCart();
  }, true);

  /* ---------- Refresco de los avisos (API de secciones) ---------- */
  function refresh(delay) {
    if (!hosts().length) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var my = ++seq;
      fetch(root + 'cart?section_id=' + SECTION, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html || my !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          hosts().forEach(function (h) {
            var src = doc.querySelector('[data-aura-goals-src="' + h.getAttribute('data-aura-goals-host') + '"]');
            if (src) { h.innerHTML = src.innerHTML; h.removeAttribute('aria-busy'); }
          });
          apply();
        })
        .catch(function () {});
    }, delay == null ? 200 : delay);
  }

  function onMutation() {
    // El aviso «Artículo agregado» no debe enseñar el estado anterior mientras llega el nuevo.
    document.querySelectorAll('[data-aura-goals-host="notification"]').forEach(function (h) {
      h.setAttribute('aria-busy', 'true');
      var g = h.querySelector('[data-aura-goals]');
      if (g) g.hidden = true;
    });
    refresh();
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (MUTATION_RE.test(url)) p.then(onMutation, function () {});
    } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  var xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__auraGoalsUrl = String(u || ''); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (MUTATION_RE.test(this.__auraGoalsUrl || '')) this.addEventListener('loadend', onMutation);
    return xs.apply(this, arguments);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
  }

  /* ---------- Retirar muestra ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-aura-remove-gift]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var line = b.getAttribute('data-line');
    var input = line && document.getElementById('Quantity-' + line);
    var trash = line && document.querySelector('cart-items cart-remove-button[data-index="' + line + '"]');
    b.disabled = true;
    b.textContent = b.getAttribute('data-busy-text') || b.textContent;
    // Mismo camino que la papelera de esa línea (comprobando que la línea es la muestra).
    if (trash && input && String(input.getAttribute('data-quantity-variant-id')) === String(CFG.giftVariant)) {
      trash.click();
      return;
    }
    nativeFetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: 0 })
    }).then(function () {
      if (isCartPage()) location.reload(); else onMutation();
    }).catch(function () { b.disabled = false; });
  });

  /* ---------- Arranque ---------- */
  function watch() {
    // El pie del carrito lo vuelve a dibujar Dawn (cantidades) y Welcome Gift (muestra, códigos): se reaplica el estado.
    var footer = document.getElementById('main-cart-footer');
    var queued = false;
    if (footer && window.MutationObserver) {
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; apply(); }, 50);
      }).observe(footer, { childList: true, subtree: true });
    }
    var notif = document.getElementById('cart-notification');
    if (notif && window.MutationObserver) {
      new MutationObserver(function () {
        if (notif.classList.contains('active')) refresh(0);
      }).observe(notif, { attributes: true, attributeFilter: ['class'] });
    }
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(0); });

  window.__auraGoals = { cfg: CFG, refresh: refresh, state: readState, locked: isLocked };
})();
